import { SocialSharing } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';

import type { ShareAction as ShareActionType } from 'src/app/shared/hooks/share';

import { useSocialIconWithSuccessState } from './hooks/useSocialIconWithSuccessState';

type SocialSharingVariant = React.ComponentProps<typeof SocialSharing>['variant'];
type SocialSharingSize = React.ComponentProps<typeof SocialSharing>['size'];

type Props = {
	buttonConfig: {
		ShareAction: ShareActionType['ShareAction'];
		icon: React.ReactElement;
		label: TranslationKey;
		successLabel?: TranslationKey;
		variant?: SocialSharingVariant;
	};
	size?: SocialSharingSize;
} & Omit<React.ComponentProps<typeof SocialSharing>, 'label' | 'icon' | 'variant' | 'size' | 'onClick'>;

export type { Props as SocialIconWithSuccessStateProps };

export const SocialIconWithSuccessState = ({
	buttonConfig: { ShareAction, icon, label, successLabel, variant },
	size = 'large',
	...rest
}: Props): React.ReactElement => {
	const { typedTranslate } = useI18n();
	const { data, actions } = useSocialIconWithSuccessState({ label, successLabel });

	return (
		<ShareAction onAfterAction={actions.afterShare}>
			<SocialSharing
				icon={icon}
				label={typedTranslate(data.currentLabel)}
				variant={variant ?? 'default'}
				size={size}
				{...rest}
			/>
		</ShareAction>
	);
};
